module.exports = __webpack_public_path__ + "static/lframe-better-things-784fc9fd56a7e46fe854df06a268b70b.png";